import axios from "axios";
import { CONFIG } from "@/constants/config.js";

const distributorPaymentHistoryBackend =
  CONFIG.BACKEND_URL + "distributorPayment";

const state = {
  distributorPaymentHistory: [],
  selectedDistributorPayment: null,
  loading: false,
  error: "",
  currentPage: 1,
  numPages: 1,
  totalRows: 0,
};

const config = () => ({
  headers: {
    Token: localStorage.getItem("accessToken"),
  },
});

const getters = {
  distributorPaymentHistory: (state) => state.distributorPaymentHistory,
  selectedDistributorPayment: (state) => state.selectedDistributorPayment,
  distributorPaymentHistoryLoading: (state) => state.loading,
  distributorPaymentHistoryError: (state) => state.error,
  distributorPaymentHistoryCurrentPage: (state) => state.currentPage,
  distributorPaymentHistoryNumPages: (state) => state.numPages,
  distributorPaymentHistoryTotalRows: (state) => state.totalRows,
};

const actions = {
  async getDistributorPaymentHistory({ commit }, { id, filter = null }) {
    commit("setLoading", true);
    await axios
      .post(
        `${distributorPaymentHistoryBackend}/distributor/${id}/`,
        filter,
        config()
      )
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributorPaymentHistory", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          console.log(error);
        }
      });
  },
  async getDistributorInvoicePaymentHistory({ commit }, { id, filter = null }) {
    commit("setLoading", true);
    await axios
      .post(
        `${distributorPaymentHistoryBackend}/invoice/${id}/`,
        filter,
        config()
      )
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributorPaymentHistory", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          console.log(error);
        }
      });
  },
  async getDistributorPayment({ commit }, id) {
    commit("setLoading", true);
    await axios
      .get(`${distributorPaymentHistoryBackend}/${id}/`, config())
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setSelectedDistributorPayment", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        commit("setLoading", false);
        await commit("setSelectedDistributorPayment", null);
        if (error.response) {
          commit("setError", error.response.data.message);
        } else {
          console.log(error);
        }
      });
  },
  async addDistributorPayment({ commit }, payment) {
    commit("setLoading", true);
    await axios
      .post(`${distributorPaymentHistoryBackend}/insert/`, payment, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error.data.message);
        throw error;
      });
  },
  async updateDistributorPayment({ commit }, payment) {
    commit("setLoading", true);
    await axios
      .patch(`${distributorPaymentHistoryBackend}/update/`, payment, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error.data.message);
        throw error;
      });
  },
  async deleteDistributorPayment({ commit }, id) {
    commit("setLoading", true);
    await axios
      .delete(`${distributorPaymentHistoryBackend}/delete/${id}/`, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error.data.message);
        throw error;
      });
  },
};

const mutations = {
  reset(state) {
    state.distributorPaymentHistory = [];
    state.selectedDistributorPayment = null;
    state.loading = false;
    state.error = "";
    state.currentPage = 1;
    state.numPages = 1;
    state.totalRows = 0;
  },
  setDistributorPaymentHistory(state, response) {
    state.distributorPaymentHistory = response.paymentHistory;
    state.currentPage = response.currentPage;
    state.numPages = response.numPages;
    state.totalRows = response.totalRows;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  setSelectedDistributorPayment(state, payment) {
    state.selectedDistributorPayment = payment;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
